import * as React from 'react';
import privateIcon from '../../assets/icons/reports/privateGroup.svg';
import publicIcon from '../../assets/icons/reports/publicGroup.svg';
import projectIcon from '../../assets/icons/reports/project.svg';
import './ReportPage.scss';
import { Outlet, useNavigate } from 'react-router-dom';
import { AccessStore } from '../../store/Access';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import ReportDetailOrg from './ReportDetailOrg';
import ReportDetailDep from './ReportDetailDep';
import { ReportSector } from './ReportSector';
import { ReportProject } from './ReportProject';
import { Layout } from '@iba-team/portal-react-components/dist';

export const ReportsListPage =  observer(() => {
  const navigate = useNavigate();
  const {allAccesses} = AccessStore;
  const [reports,setReports ] = useState<any[]  | undefined>();

  useEffect(()=>{
    setReports(allAccesses.map(item=>{
      switch (item.label){
      case 'Organization':
        return {
          ...item,
          image: publicIcon,
          description: item.description,
          title: item.name,
        };
      case 'Organization V2':
        return {
          ...item,
          image: publicIcon,
          description: item.description,
          title: item.name,
        };
      case 'Department':
        return {
          ...item,
          image: privateIcon,
          description: item.description,
          title: item.name,
        };
      case 'Project(s)':
        return{
          ...item,
          image: projectIcon,
          description: item.description,
          title: item.name,
        };
      case 'Division':
        return {
          ...item,
          image: privateIcon,
          description: item.description,
          title: item.name,
        };
      }
      return null;
    }).filter(Boolean));
  },[allAccesses]);


  return (
    <>
      {reports?.length === 1 ?
        <>
          {reports[0]?.label === 'Organization' && <ReportDetailOrg />}
          {reports[0]?.label === 'Department' && <ReportDetailDep />}
          {reports[0]?.label === 'Division' && <ReportSector />}
          {reports[0]?.label === 'Project(s)' && <ReportProject />}
        </>
        :
        <div className={'reportsListPage'}>
          {
            reports?.map((report, index) =>
              report !== undefined && 
              <Layout key={index} className={'reportsListPage__item'}>
                <div className={'report'} onClick={() => navigate(report?.refs.route)}>
                  <img src={report?.image} alt={'reportImage'} />
                  <div className={'report__content'}>
                    <div className={'report__content__header'}>
                      <h2 className={'report__content__header__title'}>
                        {report?.title}
                      </h2>
                    </div>
                    <div className={'report__content__description'}>
                      <p>{report?.description}</p>
                    </div>
                  </div>
                </div>
              </Layout>
            )
          }
        </div>
      }
      <Outlet />
    </>
  );
});
